import React, { useState, useEffect } from 'react';
import { ChevronDown } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const QUOTE_ID = 'Cg92MpgH48fhas';

const Accordion = ({ title, children, onOpen }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);

        if (next && onOpen) {
            onOpen(title);
        }
    };
    return (
        <div className={`accordion ${isOpen ? "open" : ""}`}>
            <button className="accordion-trigger" onClick={handleToggle}>
                <h3>{title}</h3>
                <ChevronDown className={`accordion-icon ${isOpen ? "rotated" : ""}`} />
            </button>
            {isOpen && <>{children}</>}
        </div>
    );
};

function Quote_Cg92MpgH48fhas() {
    const navigate = useNavigate();
    const [input, setInput] = useState('');
    const [unlocked, setUnlocked] = useState(false);
    const [error, setError] = useState('');
    const [suppressNotifications, setSuppressNotifications] = useState('');

    const [quoteData, setQuoteData] = useState(null);

    useEffect(() => {
        fetch(`/api/quoteRoute/${QUOTE_ID}`)
            .then(r => r.json())
            .then(setQuoteData);
    }, []);

    const unlock = (suppressNotification = false, meta = {}) => {
        setUnlocked(true);
        setSuppressNotifications(suppressNotification);

        if (suppressNotification) return;

        fetch('/api/quoteRoute/viewed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                unlockMethod: meta.method,
                unlockValue: meta.value
            })
        }).catch(() => { });
    };

    const trackAccordionOpen = (sectionTitle) => {
        if (suppressNotifications) return;
        fetch('/api/quoteRoute/interaction', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                quoteId: QUOTE_ID,
                type: 'accordion_open',
                section: sectionTitle
            })
        }).catch(() => { });
    };

    if (!unlocked) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f9fafb' }}>
                <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '2rem', width: '100%', maxWidth: '380px', textAlign: 'center' }}>
                    <img src='/transparent-logo-min.png' alt='Logo' style={{ width: '100%', marginBottom: '1rem' }} />
                    <h2 style={{ marginBottom: '0.25rem' }}>Your Quote</h2>
                    <p style={{ color: '#6b7280', marginBottom: '1.5rem', fontSize: '0.9rem' }}>North Florida Home Repair & Maintenance</p>
                    <input
                        type="text"
                        placeholder="Enter your access code"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                const cleaned = input.replace(/\D/g, '') || input.trim();
                                const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                                const phone1 = normalize(quoteData?.clientPhone);
                                const phone2 = normalize(quoteData?.clientPhone2);
                                const password = normalize(quoteData?.customPassword);

                                if (cleaned === '1131') {
                                    unlock(true, { method: 'override', value: cleaned });
                                } else if (cleaned === phone1) {
                                    unlock(false, { method: 'clientPhone', value: cleaned });
                                } else if (cleaned === phone2) {
                                    unlock(false, { method: 'clientPhone2', value: cleaned });
                                } else if (cleaned === password) {
                                    unlock(false, { method: 'customPassword', value: cleaned });
                                } else {
                                    setError('Incorrect. Try again.');
                                }
                            }
                        }}
                        style={{ padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box', marginBottom: '0.5rem' }}
                    />
                    {error && <p style={{ color: '#ef4444', fontSize: '0.875rem', margin: '0 0 0.5rem' }}>{error}</p>}
                    <button
                        onClick={() => {
                            const cleaned = input.replace(/\D/g, '') || input.trim();
                            const normalize = v => v?.replace(/\D/g, '') || v?.trim();

                            const phone1 = normalize(quoteData?.clientPhone);
                            const phone2 = normalize(quoteData?.clientPhone2);
                            const password = normalize(quoteData?.customPassword);

                            if (cleaned === '1131') {
                                unlock(true, { method: 'override', value: cleaned });
                            } else if (cleaned === phone1) {
                                unlock(false, { method: 'clientPhone', value: cleaned });
                            } else if (cleaned === phone2) {
                                unlock(false, { method: 'clientPhone2', value: cleaned });
                            } else if (cleaned === password) {
                                unlock(false, { method: 'customPassword', value: cleaned });
                            } else {
                                setError('Incorrect. Try again.');
                            }
                        }}
                        style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', padding: '0.65rem 1.25rem', fontSize: '0.95rem', cursor: 'pointer', width: '100%' }}
                    >
                        View quote
                    </button>
                </div>
            </div>
        );
    }
    return (
        <div className='app'>
            <main className='page' style={{ paddingTop: 0 }}>
                <section className='section section-about'>
                    <div className='hero'>
                        <img src='/jax_small.jpg' alt='Logo' className='hero-image' />
                        <div className='hero-overlay'>
                            <div className='hero-text-box'>
                                <div className='hero-title-main'>North Florida</div>
                                <div className='hero-title-sub'>Home Repair & Maintenance</div>
                            </div>
                        </div>
                    </div>

                    <div className='custom-quote'>
                        <div className="quote-subsection" style={{ borderBottom: '2px solid #111827' }}>
                            <p>Thank you again for the opportunity to review your project. I've gone through the details and prepared the information below.</p>
                            <p>As promised, you'll find a breakdown of the quoted work. I've included notes where helpful to provide additional context around certain items.</p>
                            <p>The scope of work is outlined below. If the project includes multiple components, they are presented separately so you can move forward with any portion at your discretion. When you're ready to proceed, I can provide a formal quote for approval.</p>
                        </div>

                        <div className="quote-section">

                            <div className='quote-subsection'>
                                <h3 className="section-label">Objective</h3>
                                <div className="project-description">
                                    <strong>The objective of this project is to install a structural paver patio extension that integrates seamlessly with your existing concrete lanai. This includes a full-depth excavation to ensure a stable, free-draining base, the relocation of existing irrigation to maintain yard coverage, and a 50-foot sub-surface drainage solution to redirect roof runoff away from the new living space.</strong>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Scope of work</h3>

                                <div className="white-card">
                                    <div className="white-card-title">Common to all options:</div>
                                    <ul className="scope-list" style={{ marginTop: 0 }}>
                                        <li><strong>Sprinkler Relocation:</strong> The existing Rain Bird pop-up head sits within the paver footprint in all three scenarios, and the horizontal lateral supplying it will be severed during base excavation regardless. The head and its lateral pipe will be fully relocated to a position just outside the finished paver edge. New flex pipe, fittings, and a fresh pop-up head are included. Location TBD with client on site.</li>
                                        <li><strong>Logistics:</strong> Multi-trip heavy hauling and professional site protection.</li>
                                        <li><strong>Drainage:</strong> Trench and install 50ft of 4" rigid SDR-35 PVC pipe (not corrugated) from the downspout to a green pop-up emitter.</li>
                                        <li><strong>Excavation:</strong> Dig to a depth of 7-8" to accommodate stone, sand, and pavers.</li>
                                        <li><strong>Base Install:</strong> Install 4" of "Crush & Run" limestone, compacted in 2-inch lifts to 98% density.</li>
                                        <li><strong>Screeding:</strong> Pull a 1-inch bedding layer of coarse concrete sand.</li>
                                        <li><strong>Edging:</strong> Install heavy-duty plastic edge restraints secured with 10" steel spikes every 12 inches.</li>
                                        <li><strong>Polymeric Sand:</strong> Sweep, vibrate, and mist-activate polymeric joint sand to "lock" the field.</li>
                                        <li><strong>Disposal:</strong> Comprehensive disposal of massive soil volume included in total.</li>
                                    </ul>
                                </div>
                            </div>
                            <hr />

                            <h3 className="section-label">Option comparison</h3>

                            <div className='quote-subsection'>
                                <div className="material-choice-grid">
                                    <div className="white-card">
                                        <div className="white-card-title">Option 1: The Utility Pad (78 sq ft)</div>
                                        <div className="white-card-comment">A 6' x 13' rectangular extension. Best for a dedicated grill station or small bistro set. High efficiency due to minimal edge cuts and using the house foundation as a natural restraint for two sides.</div>
                                        <ul className="option-card-list">
                                            <li><strong>Layout:</strong> Clean 90-degree corners, standard running-bond pattern.</li>
                                            <li><strong>Logistics:</strong> Manual haul-away; lowest impact on existing turf.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 3 days (18-20 hours)</div>
                                    </div>
                                    <div className="white-card">
                                        <div className="white-card-title">Option 2: The Full Expansion (272 sq ft)</div>
                                        <div className="white-card-comment">A massive transformation that doubles your outdoor living area. Extends the full depth of the existing lanai. Requires moving ~22,000 lbs of material using compact machinery.</div>
                                        <ul className="option-card-list">
                                            <li><strong>Layout:</strong> Large-scale rectangular field. Dramatic impact on backyard aesthetics.</li>
                                            <li><strong>Logistics:</strong> 2-day specialized machinery rental included for bulk earth-moving.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 5 days (45-50 hours)</div>
                                    </div>
                                    <div className="white-card">
                                        <div className="white-card-title">Option 3: The Custom Curve (~160 sq ft)</div>
                                        <div className="white-card-comment">The "middle ground" option featuring a radius edge. This design softens the transition into the lawn and creates a more organic, high-end look. Requires precision saw-cutting along the entire curved perimeter.</div>
                                        <ul className="option-card-list">
                                            <li><strong>Layout:</strong> Curved "organic" transition into the lawn.</li>
                                            <li><strong>Logistics:</strong> 1-day specialized machinery rental included for excavation.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 4 days (35-40 hours)</div>
                                    </div>
                                    <div className="white-card">
                                        <div className="white-card-title">Option 4: Full Lanai Radius (~180 sq ft)</div>
                                        <div className="white-card-comment">A design-forward expansion that mirrors the full width of the existing lanai. This layout uses a radius edge to create a high-end "custom" look while maximizing usable patio space. Requires precision saw-cutting along the entire curved perimeter.</div>
                                        <ul className="option-card-list">
                                            <li><strong>Layout:</strong> Organic curve extending across the entire lanai footprint; finished with a decorative "soldier course" border.</li>
                                            <li><strong>Logistics:</strong> 1-day specialized machinery rental included for bulk excavation and grading.</li>
                                        </ul>
                                        <div className="time-expectation"><strong>Time expectation:</strong> 4-5 days (40-45 hours)</div>
                                    </div>
                                </div>

                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Materials estimate</h3>
                                <div className="white-card">
                                    <ul className="material-card-list">
                                        <li><strong>Option 1 Materials & Disposal Fee:</strong> $1,200</li>
                                        <li><strong>Option 2 Materials & Disposal Fee:</strong> $2,950</li>
                                        <li><strong>Option 3 Materials & Disposal Fee:</strong> $1,950</li>
                                        <li><strong>Option 4 Materials & Disposal Fee:</strong> $2,100</li>
                                        <li><strong>Equipment Rental (Compactor & Wet Saw):</strong> $150</li>
                                        <li><strong>Skid Steer Rental (for option 2):</strong> $660</li>
                                        <li><strong>Skid Steer Rental (for options 3 & 4):</strong> $330</li>
                                        <li><strong>Turf Protection (Ground Shielding):</strong> Free (see note below)</li>
                                        <li><strong>Drainage/Irrigation Parts (PVC & Emitter):</strong> $120</li>
                                        <li><strong>Procurement & Delivery:</strong> $150</li>
                                    </ul>
                                </div>
                                <div className="material-note">
                                    <strong>Custom note:</strong> I will cover the cost of the ground shielding. I will be able to use that again on future projects so I consider it to be a company asset.
                                    <p>Materials and equipment are billed at exact cost and a copy of all receipts will be provided.</p>
                                    <p><strong>Procurement & Delivery</strong> covers the professional selection of quality materials, time spent at suppliers, fuel, and the logistics of transporting thousand of pounds of materials to/from the job site.</p>
                                </div>
                            </div>

                            <hr />

                            <div className='quote-subsection'>
                                <h3 className="section-label">Pricing</h3>
                                <div className="quote-pricing-block">
                                    <b>Option 1: The Utility Pad</b>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$1,300</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials estimate:</span>
                                        <span className="pricing-value">~$1,620</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$2,920</span>
                                    </div>
                                </div>
                                <div className="quote-pricing-block">
                                    <b>Option 2: The Full Expansion</b>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$3,250</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials estimate:</span>
                                        <span className="pricing-value">~$4,030</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$7,280</span>
                                    </div>
                                </div>
                                <div className="quote-pricing-block">
                                    <b>Option 3: The Custom Curve</b>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$2,600</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials estimate:</span>
                                        <span className="pricing-value">~$2,700</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$5,300</span>
                                    </div>
                                </div>
                                <div className="quote-pricing-block">
                                    <b>Option 4: Full Lanai Radius</b>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Labor (flat rate):</span>
                                        <span className="pricing-value">$2,925</span>
                                    </div>
                                    <div className="pricing-row">
                                        <span className="pricing-label">Materials estimate:</span>
                                        <span className="pricing-value">~$2,850</span>
                                    </div>
                                    <div className="pricing-row pricing-row--total">
                                        <span className="pricing-label">Estimated total:</span>
                                        <span className="pricing-value">$5,775</span>
                                    </div>
                                </div>
                                <div className="pricing-note">Pricing includes all prep, installation, and cleanup. <strong>North Florida Home Repair & Maintenance</strong> provides a 2-year warranty against paver shifting or settling.</div>
                            </div>

                        </div>

                        <hr style={{ marginTop: '3rem' }} />
                        <h2>Next Steps</h2>
                        <p>
                            Estimates provided are valid for 30 days. For any project that requires a material order above $500, a deposit covering material costs is required prior to scheduling. Labor is due upon completion of the work.
                        </p>
                        <p>
                            <strong>Please reach out</strong> whenever you are ready to move forward or if you have any questions!
                        </p>
                    </div>
                </section >
            </main >
            <footer className="quote-footer">
                <h1>Thank you!</h1>
                <div className="footer-brand-box">
                    <img
                        src="/transparent-logo-min.png"
                        alt="North Florida Home Repair & Maintenance"
                        className="footer-logo"
                    />
                    <div className="footer-fine-print">
                        Reliable | Insured | Professional Home Services
                    </div>
                </div>
                <div className="footer-contact-info">
                    <a href="tel:9043862663" className="contact-link">
                        (904) 386-2663
                    </a>
                    <span className="contact-divider">•</span>
                    <a href="mailto:daniel@northfloridarepair.com" className="contact-link">
                        daniel@northfloridarepair.com
                    </a>
                </div>

                <div className="footer-actions">
                    <button onClick={() => navigate('/')} className='home-button'>
                        ← Return Home
                    </button>
                </div>
            </footer>
        </div >
    );
}

export default Quote_Cg92MpgH48fhas;
